module.exports = __webpack_public_path__ + "img/Logo.b137e62d.png";